import {remote} from '../constants/environment';
import {defaultHeaders} from './headers';
import {customFetch as fetch, remoteCall} from '../utils/services';
import {IBasePaymentC2P} from '../interfaces/dtos/base-payment-c2p.interface';
import {IC2PPaymentBaseResponse} from '../interfaces/services';

export const getC2PPaymentBase = async (
  token: string,
): Promise<IC2PPaymentBaseResponse> => {
  const remoteURI = remote.getC2PPaymentBase();

  return (await remoteCall(
    async () => {
      return await fetch(remoteURI, {
        method: 'GET',
        headers: {
          ...defaultHeaders,
          'token-session': token,
        },
      });
    },
    async (response: Response) => {
      if (response.status === 201 || response.status === 200) {
        const data = await response.json();

        if (data.success && data.payload) {
          const success = true;

          return {
            success,
            payload: data.payload as IBasePaymentC2P,
          };
        } else {
          return {
            success: false,
            payload: null,
          };
        }
      }
    },
    remoteURI,
  )) as IC2PPaymentBaseResponse;
};
